import { useCallback, useMemo } from "react";
import { apiMain } from "@/common/services";
import { useFetch } from "@/common/hooks/useFetch";

export const useAdSidebar = () => {
  const fetchAdCreators = useCallback(() => apiMain.getAdsCreators({ count: 3 }), []);
  const { data, isLoading } = useFetch(fetchAdCreators);
  const adCreators = useMemo(() => data?.ads || [], [data]);

  return {
    adCreators,
    isLoading,
  };
};
